import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from "lucide-react";
import SOPTaskTable from "./SOPTaskTable";
import SOPResourceTable from "./SOPResourceTable";
import SOPInfo from "./SOPInfo";
import { useTranslation } from 'react-i18next';

const ViewSOP = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();


    const { state } = useLocation();
    let sop_instance_data = state?.data;

    return (
      <>
        <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
        <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 14px",
              borderRadius: "10px",
              background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
              boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
            }}
          >
            <ArrowLeft
              size={18}
              color="#fff"
              className="cursor-pointer"
              onClick={() => navigate(-1)}
            />
            <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
              {t('viewsopinfo')}
            </div>
          </div>
          <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px", paddingBottom: "16px" }}>
            <SOPInfo sopInstanceData={sop_instance_data} />
            <SOPTaskTable sopInstanceData={sop_instance_data} />
            <SOPResourceTable sopInstanceData={sop_instance_data} />
          </div>
        </div>
      </>
    );
};

export default ViewSOP;
